/* import __COLOCATED_TEMPLATE__ from './suggestion-card.hbs'; */
/* RESPONSIBLE TEAM: team-conversational-knowledge */

import Component from '@glimmer/component';
import { action } from '@ember/object';
import type TaskSuggestion from 'embercom/models/content-service/task-suggestion';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import type RouterService from '@ember/routing/router-service';

interface Signature {
  Args: {
    suggestion: TaskSuggestion;
    onShowConversationExplorer: (
      conversationIds: string[],
      actionName: string,
      actionSummary: string,
      conversationCount: number,
    ) => void;
  };
}

export default class SuggestionCard extends Component<Signature> {
  @service declare intl: IntlService;
  @service declare router: RouterService;

  @action
  onCardInserted(element: HTMLElement) {
    // Scroll this suggestion into view if it should auto-open
    if (this.shouldAutoOpenApiDocs) {
      // Use requestAnimationFrame to ensure the element is fully rendered
      requestAnimationFrame(() => {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      });
    }
  }

  @action
  handleViewConversations() {
    this.args.onShowConversationExplorer(
      this.args.suggestion.sampledConversationIds,
      this.args.suggestion.actionName,
      this.args.suggestion.actionSummary,
      this.args.suggestion.conversationCount,
    );
  }

  get topicsString() {
    return this.args.suggestion.topicNameList.join(', ') || '';
  }

  get shouldAutoOpenApiDocs() {
    let queryParams = this.router.currentRoute?.queryParams;
    let suggestionId = queryParams?.suggestionId;
    let showApiDocs = queryParams?.showApiDocs;

    return suggestionId === this.args.suggestion.id && showApiDocs === 'true';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::FinAiAgent::Analyze::TaskSuggestions::SuggestionCard': typeof SuggestionCard;
    'reporting/automation/fin-ai-agent/analyze/task-suggestions/suggestion-card': typeof SuggestionCard;
  }
}
